(function($) {
	$(function() {
		// Helper: Checks given element is completely visible in viewport
		function isElementInViewport(el) {
			if (null === el) {
				return false;
			}

			const rect = el.getBoundingClientRect();
			const top = rect.top;
			const bottom = rect.bottom;
			const animationTriggerHeight = window.innerHeight * 0.95;

			/**
			 * Potentially confusing logic ahead...
			 * *
			 * Condition: `bottom >= 0`
			 * Is the bottom of the element below the top of the window?
			 *
			 * Condition: `top <= animationTriggerHeight`
			 * Is the top of the element above the animation trigger height?
			 * i.e. is enough of the element visible in the screen viewport to
			 * start the animation?
			 */
			return bottom >= 0 && top <= animationTriggerHeight;
		}

		// Helper: Runs the animation the first time the element becomes visible
		function onVisibilityChange(el, callback) {
			var old_visible = false;

			return function() {
				var visible = isElementInViewport(el);

				if (visible !== old_visible) {
					old_visible = visible;
					if (typeof callback === "function") {
						callback(el);
					}
				}
			};
		}

		function animateIcon(el) {
			el.classList.toggle("animated", true);
		}

		var animated_icon_section = document.getElementById(
			"js-section--icon-animated"
		);

		// Only run this on pages with the animated section
		if (null !== animated_icon_section) {
			var animated_icons = document.getElementsByClassName("js-animated-icon");

			for (var i = 0; i < animated_icons.length; i++) {
				var animation_handler = onVisibilityChange(
					animated_icons[i],
					animateIcon
				);

				// Add event listeners to fire the animation handler function
				if (window.addEventListener) {
					addEventListener("DOMContentLoaded", animation_handler, false);
					addEventListener("load", animation_handler, false);
					addEventListener("scroll", animation_handler, false);
					addEventListener("resize", animation_handler, false);
				}
			}
		}
	});
})(jQuery);
